import { render, staticRenderFns } from "./SetupWifiManualSSID.vue?vue&type=template&id=989497fc&"
import script from "./SetupWifiManualSSID.vue?vue&type=script&lang=js&"
export * from "./SetupWifiManualSSID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports